import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import ProjectGithubCard from "./ProjectGithubCard";
import {
  projectHeading,
  gitHubLink,
  gitHubUsername,
  gitHubQuerry,
  projectsLength,
} from "../../editable-stuff/configurations.json";
import { Project } from "../Project/Project";


const ProjectGithub = () => {
  const [projectsArray, setProjectsArray] = useState([]);

  const handleRequest = useCallback((e) => {
    axios
      .get(gitHubLink + gitHubUsername + gitHubQuerry)
      .then((response) => {
        // handle success
        // console.log(response.data);
        return setProjectsArray(response.data.slice(0, projectsLength));
      })
      .catch((error) => {
        // handle error
        return console.error(error.message);
      })
      .finally(() => {
        // always executed
      });
  }, []);

  useEffect(() => {
    handleRequest();
  }, [handleRequest]);

  return (
    <div id="projects" className="jumbotron jumbotron-fluid bg-transparent m-0">
      {projectsArray.length != 0 && (
        <div className="container container-fluid p-5">
          <h1 className="display-4 pb-5">{projectHeading}</h1>
          <div className="row">
            {projectsArray.map((ProjectGithub) => (
              <ProjectGithubCard key={ProjectGithub.id} id={ProjectGithub.id} value={ProjectGithub} />
            ))}
          </div>
        </div>
      )}
      {projectsArray.length == 0 && (
        <div className="container container-fluid p-5">
          {/* <h1 className="display-4 pb-5">{projectHeading}</h1> */}
          {/* <div className="row">
            Max Limit exceeded
          </div> */}
          <Project />

        </div>
      )}
    </div>
  );
};

export default ProjectGithub;
